import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { createInitialCollaborationState } from 'src/store/collaboration/types';

export const collaborationSlice = createSlice({
  name: 'collaboration',
  initialState: createInitialCollaborationState,
  reducers: {
    setCollaborationReadOnly: (
      state,
      action: PayloadAction<{ projectId: string; readOnly: boolean }>
    ) => {
      const { projectId, readOnly } = action.payload;
      state.readOnlyByProjectId[projectId] = readOnly;
    },
    clearedCollaborationProject: (
      state,
      action: PayloadAction<{ projectId: string }>
    ) => {
      delete state.readOnlyByProjectId[action.payload.projectId];
    },
  },
});
